/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
import './bulkRestoreCsvVerification.tpl.html';

angular
  .module('chatter.bulkrestorecsvverification', [])
  .constant('BULK_RESTORE_CSV_VERIFICATION_STATE', {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED'
  })
  /**
   * Controller for the chatter.bulkRestoreCsvVerification template.
   */
  .controller(
    'ChatterBulkRestoreCsvVerificationCtrl',
    function (
      $scope,
      $filter,
      $window,
      httpBatch,
      BulkRestoreService,
      progressFactory,
      UserAgentFactory,
      CHATTER_SIZES,
      BULK_RESTORE_CSV_VERIFICATION_STATE,
      bulkRestoreCsvVerificationBatch
    ) {
      var origBulkRestoreCsvVerificationState = bulkRestoreCsvVerificationBatch.state;

      if (origBulkRestoreCsvVerificationState === BULK_RESTORE_CSV_VERIFICATION_STATE.FINISHED) {
        progressFactory.disableProgress();
      }

      /**
       * Utility function to set the scope vars for the batch bulkRestoreCsvVerification
       */
      function setBulkRestoreCsvVerificationBatchData(batch) {
        var verificationDate = moment(batch.date),
          objectTotal = batch.bulkRestoreCsvVerificationData.totalObjects || 0,
          objectCompleted = batch.bulkRestoreCsvVerificationData.objectsComplete || 0,
          expiresDate = verificationDate.clone().add(15, 'days').startOf('day');

        if (objectTotal === 1) {
          $scope.bulkRestoreCsvVerificationText = $filter('i18n')(
            'BATCH_BULK_RESTORE_CSV_VERIFICATION_DETAIL_DATE_SINGLE',
            [$filter('i18n')('CSV_VERIFIED'), verificationDate.format('MMM D[,] YYYY h:mm A'), objectCompleted]
          );
        } else {
          $scope.bulkRestoreCsvVerificationText = $filter('i18n')('BATCH_BULK_RESTORE_CSV_VERIFICATION_DETAIL_DATE', [
            $filter('i18n')('CSV_VERIFIED'),
            verificationDate.format('MMM D[,] YYYY h:mm A'),
            objectCompleted,
            objectTotal
          ]);
        }

        $scope.bulkRestoreCsvVerificationBatch = batch;
        $scope.BULK_RESTORE_CSV_VERIFICATION_STATE = BULK_RESTORE_CSV_VERIFICATION_STATE;
        $scope.expired = expiresDate.toDate().getTime() < new Date().getTime();
        $scope.expiredDateText = $filter('i18n')('BATCH_BULK_RESTORE_CSV_VERIFICATION_EXPIRES_DATE', [
          expiresDate.format('M/D/YY'),
          expiresDate.format('h:mm a')
        ]);
      }

      // Setup the scope values for the initial load of the controller
      setBulkRestoreCsvVerificationBatchData(bulkRestoreCsvVerificationBatch);

      // Watches to resize the canvas app based on the current state of the backup.
      $scope.$watch('bulkRestoreCsvVerificationInProgress ', function () {
        if (
          !$scope.bulkRestoreCsvVerificationInProgress ||
          bulkRestoreCsvVerificationBatch.state === BULK_RESTORE_CSV_VERIFICATION_STATE.FINISHED
        ) {
          // if the original bulkRestoreStatus was not Finished then load the batch.
          if (origBulkRestoreCsvVerificationState !== BULK_RESTORE_CSV_VERIFICATION_STATE.FINISHED) {
            httpBatch.getBatch($scope.stateParams.batchId).then(function (batch) {
              setBulkRestoreCsvVerificationBatchData(batch);
            });
          }
          if (!progressFactory.disabled) {
            progressFactory.disableProgress();
          }
        }
      });

      /**
       * Handler to show bulkRestoreCsvVerification details page in app.
       */
      $scope.showBulkRestoreInApp = function () {
        // Use the chatter gotoApp function.
        if (!$scope.expired) {
          $scope.gotoApp('?batchId=' + $scope.stateParams.batchId + '&page=bulkRestoreCsv');
        }
      };

      /**
       * Handler for the download invalid id csv.
       */
      $scope.downloadCsv = function () {
        if (!$scope.expired) {
          var batchId = $scope.stateParams.batchId;
          BulkRestoreService.downloadInvalidIdCsv(batchId).then(function (result) {
            var browser = UserAgentFactory.detectBrowser(),
              blob;

            //If it's IE do some black magic and use custom IE specific methods (MsSaveBlob) to save this file.
            if (browser && browser.indexOf('IE') > -1) {
              if (window.navigator.msSaveOrOpenBlob) {
                blob = new Blob([decodeURIComponent(encodeURI(result))], {
                  type: 'text/csv;charset=utf-8;'
                });
                navigator.msSaveBlob(blob, 'BulkRestoreInvalidIds.csv');
              }
            } else {
              // convert to data URI
              $window.location.href = 'data:text/csv;charset=utf8,' + encodeURI(result);
            }
          });
        }
      };
    }
  );
